import create from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { defaultHeaderState } from './data'

export type headerStoreDefault = {
  setHeaderTitle: (title: string) => void;
  setHeaderSubtitle: (subTitle?: string) => void;
  title: string;
  subTitle: string;
}

export const useHeaderStore = create<headerStoreDefault>(
  devtools
    ((set, get) => ({
      ...defaultHeaderState,
      setHeaderTitle: (title) => set({ title, subTitle: '' }),
      setHeaderSubtitle: (subTitle) => set({ subTitle }),
      reset: () => set({ ...defaultHeaderState })
    }))
)

export const UserStore = useHeaderStore.getState()
